import { ConfirmationDialog } from '@/components/Common/ConfirmationDialog/ConfirmationDialog';
import Dialog from '@/components/Common/Dialog/Dialog';
import COLORS from '@/constants/colors';
import { OpenCart, useCartContext } from '@/context/Cart/CartContext';
import { useIsMobile } from '@/utils/isMobile';
import { useRef } from 'react';
import { CreateEditCartBody } from './CreateEdit/CreateEditCartBody';
import { ViewCartBody } from './View/ViewCartBody';

export function CartModal() {
  const isMobile = useIsMobile();
  const {
    openModal,
    setOpenModal,
    openConfirmCloseModal,
    setOpenConfirmDraftOrderModal,
  } = useCartContext();

  const closeModalHandlerRef = useRef<CloseModalHandler>(null);

  const getTitle = (openCart?: OpenCart): string => {
    if (openCart?.type === 'create') return 'Crear Carrito';
    if (openCart?.type === 'edit' || openCart?.type === 'view')
      return `Carrito # ${openCart.cartNumber}`;
    return '';
  };

  const getModalText = (type?: string) => {
    if (type === 'create')
      return 'Esta acción no se puede deshacer. ¿Estás seguro de que deseas eliminar este pedido?';
    if (type === 'edit')
      return 'Esta acción no se puede deshacer. ¿Estás seguro de que deseas descartar los cambios en este pedido?';
    return '';
  };

  const isCreateOrEditCart =
    openModal?.type === 'create' || openModal?.type === 'edit';
  const isViewCart = openModal?.type === 'view';

  const dialogTitle = getTitle(openModal);
  const confirmationMessage = getModalText(openModal?.type);

  const onConfirmCloseCancel = () => {
    setOpenConfirmDraftOrderModal?.(false);
  };

  const onConfirmCloseAccept = () => {
    setOpenConfirmDraftOrderModal?.(false);
    setOpenModal?.(undefined);
  };

  return (
    <>
      <Dialog
        fullScreen={isMobile}
        open={Boolean(openModal?.type)}
        onClose={() => closeModalHandlerRef.current?.onCloseRequested()}
        title={dialogTitle}
        body={
          <>
            {isCreateOrEditCart && (
              <CreateEditCartBody ref={closeModalHandlerRef} />
            )}
            {isViewCart && <ViewCartBody ref={closeModalHandlerRef} />}
          </>
        }
        bgColor={COLORS.gray_50}
        p="16px"
        width={isMobile ? undefined : 950}
      />
      <ConfirmationDialog
        open={openConfirmCloseModal ?? false}
        title="Confirmación"
        message={confirmationMessage}
        okButton={{ label: 'Aceptar', variant: 'contained' }}
        onOkButtonListener={onConfirmCloseAccept}
        koButton={{ label: 'Cancelar', variant: 'outlined' }}
        onKoButtonListener={onConfirmCloseCancel}
        cancelable
      />
    </>
  );
}

export interface CloseModalHandler {
  onCloseRequested: () => void;
}
